import Vue, {DirectiveBinding, VNode, VueConstructor} from 'vue'

Vue.config.productionTip = false;

const install = (Vue: VueConstructor) => {
	const reactorComponent = new Vue({
		data() {
			return  {
	    		elementInFocus: <HTMLElement|null> null,
	  		}
	  	},

	  	watch: {
			elementInFocus: function(value) {
	  			if(value) {
					document.body.classList.add('element-in-focus');
	  			} else {
					document.body.classList.remove('element-in-focus');
	  			}
	  		}
	  }
	})

	Vue.directive('focusable', {
		bind: (el: HTMLElement, binding: DirectiveBinding<string>, vnode: VNode) => {
			el.onclick = () => {
				reactorComponent.elementInFocus = el;
				vnode.context?.$root.$once('bv::popover::hide', () => {
					reactorComponent.elementInFocus = null;
				})
			};
		}
	})
}

export default { install }
